import React from "react";
import { Button } from "reactstrap";
import { API } from "../../../http/API";

const ClearCache = () => {
  const removeCache = () => {
    API.get("/clear-cache")
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          alert(response.data || "Cache has been flushed.");
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <div
      className="mr-auto float-left bookmark-wrapper d-flex align-items-center"
      style={{ padding: "0.7rem 1rem" }}
    >
      <Button className="cacheBtn" onClick={removeCache}>
        Clear Cache
      </Button>
    </div>
  );
};

export default ClearCache;
